export const GET_FINISHED_AUCTIONS = 'GET_FINISHED_AUCTIONS';
